// utils/device.js
export function getDeviceFingerprint() {
    const navigatorInfo = window.navigator;
    const screenInfo = window.screen;
  
    const raw = [
      navigatorInfo.userAgent,
      navigatorInfo.language,
      screenInfo.colorDepth,
      screenInfo.width,
      screenInfo.height,
      screenInfo.availHeight,
      screenInfo.availWidth,
      navigatorInfo.hardwareConcurrency,
      navigatorInfo.platform,
      navigatorInfo.deviceMemory,
    ].join("::");
  
    return btoa(raw).substring(0, 32); // 32-char fingerprint
  }
  